import React from 'react'
import {
  withRouter
} from 'react-router'

class SelectionModeSwitcher extends React.Component {
  // props: onSelect
  componentDidUpdate(prevProps) {
    //console.log("SelectionModeSwitcher::componentDidUpdate()")
    if (this.props.location !== prevProps.location) {
      console.log("change to: ", this.props.location);
      if (this.props.location.pathname==="/selections") {
        console.log("call onSelect()")
        this.props.onSelect();
      }
      if (this.props.location.pathname.startsWith('/selection/')) {
        const match = this.props.location.pathname.match(/\/selection\/([^/]+)/);
        console.log(match);
        if (match.length>1) {
          const id = match[1];
          this.props.onPickSelection(id);
        }
      }
    }
  }
  render() {
    return null;
  }
}

export default withRouter(SelectionModeSwitcher)
